<template>
  <div class="paytype-page">
    <!-- 顶部操作栏 -->
    <el-card class="tool-card" shadow="never">
      <div class="tool-row">
        <div class="tool-left">
          <span class="tool-title">收款平台管理</span>
          <span class="tool-sub">核算比例用于计算业绩：业绩 = 订单金额 × 比例（订单创建时选择平台）</span>
        </div>
        <el-button type="primary" icon="el-icon-plus" @click="openEdit(null)">新增平台</el-button>
      </div>
    </el-card>

    <!-- 列表 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="list"
        :header-cell-style="{ background: '#F7F9FC', color: '#18233C', fontWeight: 600 }"
        empty-text="暂无收款平台"
      >
        <el-table-column prop="name" label="平台名称" min-width="160">
          <template slot-scope="{ row }">
            <div class="pt-name">
              <i class="el-icon-credit-card pt-name-icon"></i>
              <span>{{ row.name }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="核算比例" min-width="130" align="center">
          <template slot-scope="{ row }">
            <span class="rate-num">{{ (parseFloat(row.rate) * 100).toFixed(1) }}%</span>
            <span class="rate-sub">（{{ row.rate }}）</span>
          </template>
        </el-table-column>
        <el-table-column label="排序" prop="weigh" min-width="70" align="center">
          <template slot-scope="{ row }">
            <span class="weigh-num">{{ row.weigh }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" min-width="90" align="center">
          <template slot-scope="{ row }">
            <el-tag :type="parseInt(row.status) === 1 ? 'success' : 'info'" size="small">
              {{ parseInt(row.status) === 1 ? '启用' : '停用' }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="备注" prop="remark" min-width="180" show-overflow-tooltip>
          <template slot-scope="{ row }">
            <span class="remark-text">{{ row.remark || '—' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" size="small" @click="openEdit(row)">编辑</el-button>
            <el-button type="text" size="small" class="del-btn" @click="doDelete(row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="editId ? '编辑收款平台' : '新增收款平台'" :visible.sync="editVisible" width="480px">
      <el-form ref="form" :model="form" :rules="rules" label-width="90px" size="small">
        <el-form-item label="平台名称" prop="name">
          <el-input v-model="form.name" placeholder="如：微信、支付宝、对公" :maxlength="50" />
        </el-form-item>
        <el-form-item label="核算比例" prop="rate">
          <el-input-number v-model="form.rate" :min="0.01" :max="1" :step="0.01" :precision="4" style="width: 200px" />
          <div class="form-hint">
            业绩 = 订单金额 × 核算比例。当前为 {{ (form.rate * 100).toFixed(1) }}%
          </div>
        </el-form-item>
        <el-form-item label="排序">
          <el-input-number v-model="form.weigh" :min="0" :max="9999" style="width: 200px" />
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.status" active-text="启用" inactive-text="停用" />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="2" :maxlength="200" placeholder="选填" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="editVisible = false">取 消</el-button>
        <el-button type="primary" size="small" :loading="saving" @click="doSave">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { paytypeList, paytypeSave, paytypeDelete } from '@/api/base'

export default {
  name: 'PaytypeList',
  data() {
    return {
      list: [],
      loading: false,
      editVisible: false,
      editId: 0,
      saving: false,
      form: { name: '', rate: 1, weigh: 0, status: true, remark: '' },
      rules: {
        name: [
          { required: true, message: '请填写平台名称', trigger: 'blur' },
          { max: 50, message: '最多 50 字', trigger: 'blur' }
        ],
        rate: [{ required: true, message: '请设置核算比例', trigger: 'change' }]
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      this.loading = true
      paytypeList({ manage: 1 })
        .then(data => { this.list = data.list || [] })
        .catch(() => { this.list = [] })
        .finally(() => { this.loading = false })
    },
    openEdit(row) {
      if (row) {
        this.editId = row.id
        this.form = {
          name: row.name,
          rate: parseFloat(row.rate),
          weigh: parseInt(row.weigh) || 0,
          status: parseInt(row.status) === 1,
          remark: row.remark || ''
        }
      } else {
        this.editId = 0
        this.form = { name: '', rate: 1, weigh: 0, status: true, remark: '' }
      }
      this.editVisible = true
    },
    doSave() {
      this.$refs.form.validate(valid => {
        if (!valid) return
        this.saving = true
        paytypeSave({
          id: this.editId,
          name: this.form.name.trim(),
          rate: this.form.rate,
          weigh: this.form.weigh,
          status: this.form.status ? 1 : 0,
          remark: (this.form.remark || '').trim()
        })
          .then(() => {
            this.$message.success(this.editId ? '修改成功' : '新增成功')
            this.editVisible = false
            this.load()
          })
          .catch(() => {})
          .finally(() => { this.saving = false })
      })
    },
    doDelete(row) {
      this.$confirm(`确认删除收款平台「${row.name}」？`, '删除平台', {
        confirmButtonText: '删 除',
        cancelButtonText: '取 消',
        type: 'warning'
      }).then(() => {
        paytypeDelete(row.id)
          .then(() => {
            this.$message.success('删除成功')
            this.load()
          })
          .catch(() => {})
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.paytype-page { padding: 0; }

.tool-card {
  margin-bottom: 14px;
  border-radius: 10px;
  border: 1px solid #E5E9F2;
}

.tool-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
}

.tool-left { display: flex; align-items: baseline; gap: 12px; }

.tool-title {
  font-size: 15px;
  font-weight: 700;
  color: #18233C;
}

.tool-sub {
  font-size: 12px;
  color: #8A94AD;
}

.table-card {
  border-radius: 10px;
  border: 1px solid #E5E9F2;
}

.pt-name {
  display: flex;
  align-items: center;
  gap: 8px;
}

.pt-name-icon {
  font-size: 15px;
  color: #3668FC;
  background: #EDF3FE;
  border-radius: 6px;
  padding: 4px;
}

.rate-num {
  font-size: 14px;
  font-weight: 700;
  color: #E8930C;
}

.rate-sub {
  font-size: 12px;
  color: #8A94AD;
  margin-left: 4px;
}

.weigh-num { color: #5A6580; }

.remark-text { color: #5A6580; }

.del-btn { color: #E5484D; }

.form-hint {
  margin-top: 6px;
  font-size: 12px;
  color: #8A94AD;
}

/* ===== Element UI 品牌色统一 ===== */
::v-deep .el-button--primary {
  background: #3668FC;
  border-color: #3668FC;
}

::v-deep .el-button--primary:hover,
::v-deep .el-button--primary:focus { background: #5B8DFF; border-color: #5B8DFF; }

::v-deep .el-table__row:hover > td {
  background: #F5F8FF !important;
}
</style>
